module.exports = __webpack_public_path__ + "static/fonts/SCDream7.3bd0c8c.otf";